import React from 'react';
export const Adoptable16 = ({ className })=>/*#__PURE__*/ React.createElement("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M2.33335 5.66657V4.9999H1.66669L1.66669 5.66657H2.33335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.00002 6.33323V5.66656L2.33335 5.66657L2.33335 6.33323H3.00002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.00002 5.66656V4.9999H2.33335V5.66657L3.00002 5.66656Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.00002 4.9999V4.33323H2.33335L2.33335 4.9999H3.00002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.66669 6.9999V6.33323L3.00002 6.33323L3.00002 6.9999H3.66669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.66669 6.33323V5.66656H3.00002V6.33323L3.66669 6.33323Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.66669 5.66656V4.9999H3.00002V5.66656H3.66669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.66669 4.9999V4.33323H3.00002V4.9999H3.66669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.66669 4.33323L3.66669 3.66656H3.00002L3.00002 4.33323H3.66669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.33335 7.66657V6.9999L3.66669 6.9999L3.66669 7.66657H4.33335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.33335 6.9999V6.33323H3.66669V6.9999L4.33335 6.9999Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.33335 6.33323V5.66656H3.66669V6.33323H4.33335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.33335 5.66656V4.9999H3.66669V5.66656H4.33335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.33335 4.9999L4.33335 4.33323H3.66669V4.9999H4.33335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.33335 4.33323V3.66656H3.66669L3.66669 4.33323H4.33335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.33335 3.66656V2.9999H3.66669L3.66669 3.66656H4.33335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.00002 8.33323V7.66656L4.33335 7.66657L4.33335 8.33323H5.00002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.00002 7.66656V6.9999H4.33335V7.66657L5.00002 7.66656Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.00002 6.9999V6.33323H4.33335V6.9999H5.00002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.00002 6.33323V5.66656L4.33335 5.66656V6.33323H5.00002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.00002 5.66656V4.9999L4.33335 4.9999V5.66656L5.00002 5.66656Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.00002 4.9999L5.00002 4.33323L4.33335 4.33323L4.33335 4.9999L5.00002 4.9999Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.00002 4.33323V3.66656H4.33335V4.33323L5.00002 4.33323Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.00002 3.66656V2.9999H4.33335V3.66656H5.00002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.00002 2.9999L5.00002 2.33323H4.33335L4.33335 2.9999H5.00002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.66669 7.66657V6.9999H5.00002V7.66656L5.66669 7.66657Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.66669 6.9999V6.33323H5.00002V6.9999H5.66669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.66669 6.33323V5.66656L5.00002 5.66656V6.33323H5.66669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.66669 5.66656V4.9999L5.00002 4.9999V5.66656L5.66669 5.66656Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.66669 4.9999L5.66669 4.33323L5.00002 4.33323L5.00002 4.9999L5.66669 4.9999Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.66669 4.33323V3.66656H5.00002V4.33323L5.66669 4.33323Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.66669 3.66656L5.66665 2.9999H5.00002V3.66656H5.66669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.33335 3.66657V2.9999L5.66665 2.9999L5.66669 3.66656L6.33335 3.66657Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.66665 2.9999L5.66665 2.33323L5.00002 2.33323L5.00002 2.9999H5.66665Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.33335 2.9999V2.33323L5.66665 2.33323L5.66665 2.9999L6.33335 2.9999Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.66665 2.33323L5.66669 1.66656L5.00002 1.66656L5.00002 2.33323L5.66665 2.33323Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.33335 6.9999V6.33323H5.66669V6.9999L6.33335 6.9999Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.33335 6.33323V5.66656H5.66669V6.33323H6.33335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.33335 5.66656V4.9999H5.66669V5.66656H6.33335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.33335 4.9999V4.33323H5.66669L5.66669 4.9999H6.33335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.33335 4.33323V3.66657L5.66669 3.66656V4.33323H6.33335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.33335 2.33323V1.66656L5.66669 1.66656L5.66665 2.33323L6.33335 2.33323Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.00002 6.33323V5.66656H6.33335V6.33323L7.00002 6.33323Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.00002 5.66656V4.9999H6.33335V5.66656H7.00002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.00002 4.9999V4.33323H6.33335V4.9999H7.00002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.00002 4.33323V3.66656L6.33335 3.66657V4.33323H7.00002Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.00002 2.33323V1.66656L6.33335 1.66656V2.33323L7.00002 2.33323Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.00002 2.66657V1.9999L6.33335 1.9999V2.66657L7.00002 2.66657Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.66669 5.66657V4.9999H7.00002V5.66656L7.66669 5.66657Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.66669 4.9999V4.33323H7.00002V4.9999H7.66669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.66669 4.33323V3.66656H7.00002V4.33323H7.66669Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.66669 2.66656V1.66656L7.00002 1.66656V2.66657L7.66669 2.66656Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.33335 4.9999V4.33323H7.66669V4.9999L8.33335 4.9999Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.33335 4.33323V3.66656H7.33335V4.33323H8.33335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.33335 3.66656V2.9999H7.33335V3.66656H8.33335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.33335 2.9999V2.33323H7.33335V2.9999H8.33335Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.33335 2.33323V1.66657L7.66669 1.66656L7.66669 2.33324L8.33335 2.33323Z",
        fill: "currentColor"
    }));
Adoptable16.displayName = 'Adoptable16';
export default Adoptable16;
